import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-cobalt/5 px-5 py-10" data-id="element-162" data-mp="3fyhq1vsbkxc4">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-163" data-mp="2eta7e7at68hv">
        <p className="text-sm font-medium text-ink sm:text-base" data-id="element-164" data-mp="29u5yzivpkesl">
          <span className="tracking-tight text-cobalt" data-id="element-165" data-mp="29scv2bchc8oa">⭐⭐⭐⭐⭐</span> 4.9/5 · Trusted by Chemistry
          teachers across the USA, UK &amp; Canada
        </p>
      </div>
    </section>;
}